<template>
  <v-data-table
    locale="es-ES"
    dense
    mobile-breakpoint="0"
    item-class="style"
    :headers="headers"
    :items="lineas"
    :items-per-page="4"
    class="elevation-1"
    group-by="Proyecto"    
    show-group-by    
    :footer-props="{
        itemsPerPageOptions: [2,4,6], // -> Add this example        
        itemsPerPageText: 'Lineas por pág.',        
        pageText: '{0}-{1} de {2}'
    }"
    :header-props="{
        sortByText: 'Ordenar por'
    }"
    @click:row="editMode"
  >
    <template v-slot:no-data>
        Impute horas para ver aquí el resumen
    </template>
    <template v-slot:no-results>
        Impute horas para ver aquí el resumen
      </template>
  </v-data-table>
</template>
<script>
  export default {
        //:rows-per-page-items="rowsPerPageItems"
        //:rows-per-page-text="rowsPerPageText"
        //:pagination.sync="pagination" 
        name: 'TimeTable',
        data () {
            return {         
                headers: [                
                {
                    text: 'Tarea',
                    align: 'start',
                    sortable: true,
                    value: 'jobTaskName',
                    groupable : false
                },
                { text: 'HR', value: 'hourCount', groupable : false },
                { text: 'Ud.', value: 'invoiceableCountUom', groupable : false },
                { text: 'Cantidad Fact', value: 'invoiceableCount', groupable : false }
                ],                
            }
        },
        mounted(){
            if ((window.location.pathname == '/Resumen') || (window.location.pathname == '/ResumenEdit')){
                this.headers= [                
                {
                    text: 'Tarea',
                    align: 'start',
                    sortable: true,
                    value: 'jobTaskName',
                    groupable : false
                },
                { text: 'Ud.', value: 'invoiceableCountUom', groupable : false },
                { text: 'Cantidad Fact', value: 'invoiceableCount', groupable : false }
                ]
            }
        },
        methods:{
            editMode(val){
                var index = this.lineas.indexOf(val);
                //DT Vila - 13912 - 03.03.25
                //Se permite el click en lineas validadas:
                //if ((this.lineas[index].validated == undefined) || (this.lineas[index].validated == false)){
                    this.$store.commit('saveIndexEditLine',index);
                    if (!val.invoiceableCountUom){ //Input horas personal                    
                        //this.$store.state.dialogInputHorasPersonal = true;
                        this.$router.push('HorasPersonal');
                    } else { //Input horas
                        //this.$store.state.dialogInputHoras = true;
                        this.$router.push('Horas');
                    }
                //}
            }
        },
        computed:{
            lineas:{
                get(){
                    if ((window.location.pathname == '/Resumen') || (window.location.pathname == '/ResumenEdit'))
                        return this.$store.state.lineasParte.filter(linea => linea.invoiceableCount > 0);
                    else 
                        return this.$store.state.lineasParte.filter(linea => !linea.adicional);
                }            
            }
        }
    }
</script>
<style >
    .validated{
        background-color: lightgreen;
    }
</style>